export default "__VITE_ASSET__CFv$ujCt__"